import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import apiService from '../../services/api.service'
import { messageActions } from '../../store/message'
import _ from 'lodash'
import { resultadoIncerto, textoRecusaContrassenha } from '../../components/contrassenha/contrassenha.utils'

const BASE_PATH = '/lottustech/remessaspagamentos'
const crud = build(validate, BASE_PATH)
const prefix = 'crudRemessaPagamento'

/** Estado do envio do Gerar no store (null = livre). */
export const ENVIO_GERAR = {
  ENVIANDO: 'ENVIANDO',
  INCERTO: 'INCERTO',
}

const newTypes = {
  RESET: `${prefix}reset`,
  ENVIO_GERAR: `${prefix}envioGerar`,
  ADD_ITEM: `${prefix}addItem`,
  SET_ITEM: `${prefix}setItem`,
  ON_CLICK_REMOVE_ITEM: `${prefix}onClickRemoveItem`,
}

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.reset = () => {
  return {
    type: types.RESET,
  }
}
actions.addItem = (payload) => {
  return {
    type: types.ADD_ITEM,
    payload,
  }
}

actions.setItem = (prop, value) => {
  return {
    type: types.SET_ITEM,
    prop,
    value,
  }
}

actions.onClickRemoveItem = (payload) => {
  return {
    type: types.ON_CLICK_REMOVE_ITEM,
    payload,
  }
}

actions.envioGerar = (payload) => {
  return {
    type: types.ENVIO_GERAR,
    payload,
  }
}

/**
 * Gera a remessa com a contrassenha ja digitada no dialogo (PHOENIX-959). Devolve a Promise para o dialogo: recusa da
 * contrassenha e resultado incerto (sem resposta, 502/503/504) rejeitam sem mensagem global - o dialogo mostra o texto
 * e fica aberto; outra falha mostra a mensagem de sempre e tambem rejeita, para o dialogo fechar.
 *
 * O estado do envio fica no store ({@link ENVIO_GERAR}): enquanto um envio esta no ar ou depois de um incerto, nao sai
 * outro - nem saindo da tela e voltando. Incerto so libera recarregando a pagina. Sucesso limpa os itens (reset).
 */
actions.gerarRemessa = (data) => {
  return (dispatch, getState) => {
    if (_.get(getState(), 'crudRemessaPagamentoState.envioGerar')) {
      // nao chega a enviar: o dialogo fecha (falha sem request = nada aconteceu)
      return Promise.reject(new Error('Remessa de pagamento ja enviada ou com resultado incerto'))
    }
    dispatch(actions.envioGerar(ENVIO_GERAR.ENVIANDO))
    const path = BASE_PATH + `/gerar`
    // .then(sucesso, falha), e nao .then().catch(): um erro no tratamento do sucesso (a remessa ja saiu) nao pode cair
    // no tratamento de falha, que liberaria o Gerar com os mesmos itens
    return apiService.post(path, data).then(
      (response) => {
        try {
          dispatch(
            messageActions.messageShowMessages(
              makeMessages(['Remessa enviada com sucesso. Favor aguardar o processamento.'], 'success')
            )
          )
          dispatch(actions.reset())
        } catch (erroAposSucesso) {
          // a remessa saiu; sem saber se a tela ficou certa, trava como incerto (conferir antes de gerar de novo)
          dispatch(actions.envioGerar(ENVIO_GERAR.INCERTO))
          throw erroAposSucesso
        }
      },
      (error) => {
        const incerto = resultadoIncerto(error)
        dispatch(actions.envioGerar(incerto ? ENVIO_GERAR.INCERTO : null))
        if (error.response && textoRecusaContrassenha(error) === null && !incerto) {
          const messages = error.response.data
          dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
        }
        throw error
      }
    )
  }
}

const makeMessages = (messages, type) => {
  let sticky = false
  let summary = ''
  if (type === 'error') {
    summary = ''
    sticky = true
  } else if (type === 'warn') {
    summary = ''
    sticky = true
  }
  return messages.map((message) => {
    return {
      sticky: sticky,
      summary: summary,
      severity: type,
      detail: message,
    }
  })
}
export { types, actions }
